<template>
  <sh-modal
    label="Latest updates based on user feedback"
    id="change-modal"
    modal-width="30%"
    modal-height="fit-content"
    @modal-closed="closeChangeModal"
    style="overflow-y: hidden"
  >
    <!-- <sh-icon
      slot="functions"
      button
      size="s"
      icon="rotate-2d"
      id="loadfull-icon"
      @click="loadFullChangelog"
    ></sh-icon> 
    <sh-tooltip
      label="Display entire changelog"
      target="loadfull-icon"
      placement="bottom"
      variation="short"
    ></sh-tooltip>-->
    <div style="height: calc(100% - 16px)">
      <div id="editor" class="scroll-box" v-html="compiledMarkdown"></div>
      <div class="fix-box">
        <sh-text style="text-align: end; margin-right: 10px">
          For additional feedback, send us a
        </sh-text>
        <sh-button size="s" label="message" @click="openFeedbackModal">
        </sh-button>
      </div>
    </div>
  </sh-modal>
</template>

<script>
import { marked } from "marked";
import axios from "axios";

export default {
  name: "ChangeModal",
  components: {},
  data() {
    return {
      input: "# Changelog",
      // fullInput: "# Changelog",
    };
  },
  computed: {
    compiledMarkdown: function () {
      return marked(this.input);
    },
  },
  async mounted() {
    this.getChangeLog();
  },
  watch: {},
  methods: {
    closeChangeModal() {
      document.querySelector("#change-modal").visible = false;
    },
    // loadFullChangelog() {
    //   this.input = this.fullInput;
    // },
    async getChangeLog() {
      //   console.time("readingfile");
      const changeLogTxt = await axios.get(
        process.env.BASE_URL + "changelog.md"
      );

      let replacedUrls = changeLogTxt.data.replaceAll(
        "BASE_URL",
        window.location.origin
      );
      //   console.log(changeLogTxt);

      // this.fullInput = replacedUrls;
      // this.input = replacedUrls.slice(0, 2000) + "\n\n...";
      this.input = replacedUrls;

      //   console.timeEnd("readingfile");
    },
    openFeedbackModal() {
      this.closeChangeModal();
      document.querySelector("#feedback-modal").visible = true;
    },
  },
};
</script>

<style lang="css" scoped>
#editor {
  font-family: "siemens sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 0px;
}
.scroll-box {
  max-height: 300px;
  overflow-y: scroll;
}
.fix-box {
  /* background-color: green; */
  position: sticky;
  bottom: 0;
  width: 100%;
  margin-top: 20px;
  height: 15%;
  display: flex;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.body-wrapper {
  overflow-y: hidden;
}
</style>
